export default __webpack_public_path__ + "static/media/rated.0e6483d6.svg";